<template>
<v-dialog v-model="$store.state.successModal" width="600">
  <v-card max-width="600">
      <div class="py-5 text-center">
        <h3 class="primary--text">{{ message }}</h3>
      </div>
    <v-card-text>  
      <div class="pb-5 text-center">
        <H1 class="accent--text">{{ job.jobName }}</H1>
      </div>
      <div class="text-center">
        <v-avatar size="200">
          <v-img src="@/assets/img/gorilla.jpeg"></v-img>
        </v-avatar>
        <P class="pt-3">{{ subMessage }}</P>
      </div>
      <div class="text-right">
        <v-btn color="secondary" @click="toggleSuccessModal" outlined class="ml-2">閉じる</v-btn>
      </div>
    </v-card-text>  
  </v-card>
</v-dialog>
</template>
<script>
  import { mapActions } from 'vuex'
  export default {
    props: {
      job: Object,
      message: String,
      subMessage: String
    },
    data() {
      return {
        
      }
    },
    methods: {
      ...mapActions(['toggleSuccessModal'])
    }
  }
</script>
